import {IEnvironment} from "./IEnvironment";

export const environment: IEnvironment = {
  production: true,
  env_name: 'production',
  frontend: 'https://dayfox.club',
  api: {
    url: 'https://api.dayfox.club/api',
    session_domain: '.dayfox.club'
  },
  default_artist_user_id: '97b888e0-aedb-41be-8ffa-36e8dab3ad08',
  special_playlist_id: '9aa474e4-0bed-49f4-9684-42944e505e7f',
};
